import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { ContextProvider } from './context/ContextProvider'; // Import your ContextProvider
import { rejectMalformedPaymentResultPath } from './utils/paymentResultSecurity';

console.log = function () {}; // Disable console.log

if (rejectMalformedPaymentResultPath()) {
  // Redirecting away from probe/malformed payment-result URL — do not mount React.
} else {
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
